const en = {
  renewals_title: 'Your Offer',
  renewals_offer_step: 'Internet',
  renewals_tv_step: 'TV',
  renewals_installation_step: 'Installation',
  renewals_id_step: 'ID',
  renewals_summary_step: 'Summary',
  renewals_bundle_offer: 'Bundle Offer',
  renewals_bundles_subtitle: 'Get more value for your money with Vodafone Offers!',
  renewals_chosen_plan: 'Your chosen plan',
  renewals_continue_button: 'Continue',
  renewals_confirm_button: 'Confirm',
  renewals_next_button: 'Continue to next step',
  renewals_choose_plan_button: 'Choose plan',
  renewals_choose_bundle_button: 'Continue with this bundle',
  renewals_without_tv_button: 'Continue without TV',
  renewals_notify_me_button: 'Notify me',
  renewals_cancel_button: 'Cancel',
  renewals_location_title: 'Location',
  renewals_verify_coverage: 'Verify coverage',
  renewals_verify_coverage_desc: 'We need your address to verify if you have coverage in your area',
  renewals_view_offer_button: 'View your offer',
  renewals_view_details_button: 'View details',
  renewals_get_bundle_button: 'Get this bundle',
  renewals_recommended_offer: 'Recommended offer',
  renewals_continue_without_tv_button: 'Continue without TV',
  renewals_id_step_title: 'Add your ID',
  renewals_id_step_desc: 'We need to take details of a valid from of identification so we can verify your identity. We need a photo of your ID to be able to do the check.',
  renewals_id_explaination_text: 'Please enter the details of your ID and take a photo of the same identification ID so we can run the check.',
  renewals_take_id: 'Take ID photo',
  renewals_remove_id: 'Retake ID photo',
  renewals_my_id: 'My ID',
  renewals_offer_valid: 'Offer valid for %1$s %2$s',
  renewals_combine_offer: 'Combine %1$s with: ',
  //Bundle
  bundle_choose_plan_button_label: 'Choose Plan',
  bundle_add_ons_label: 'Add ons',
  bundle_add_ons_extra_label: 'Add extra TV Add ons',
  bundle_add_ons_button_label: 'Add this add on',
  bundle_characteristic_document_label: 'High capacity and stability',
  bundle_characteristic_upload_label: '%1$s  Mbps upload speed',
  bundle_characteristic_download_label: '%1$s Mbps download speed',
  bundle_characteristic_fup_label: '%1$s broadband usage',
  book_appointment_date_step_subtitle: 'Choose when would you like us to install your device',
  book_appointment_date_step_title: 'Installation',
  renewals_modem_device: 'Modem Device',
  renewals_modem_device_description: 'Choose the right modem to fit your needs',
  renewals_installation_fee: 'Installation Fee',
  renewals_installation_fee_description: 'This price will be added to total',
  renewals_installation_fee_first_time: 'First time installation fee',
  renewals_fee_reallocation_info: 'If you want to reallocate the line in the future you will not be subject to fees',
  renewals_modem_price_info: '*The deposit will be given back once you provide back the device',
  renewals_more_info: 'More info',
  renewal_close_modal: 'Close',
  renewal_processing_action: 'Processing...',
  renewal_try_again: 'Try again',
  renewal_go_back_button: 'Go back',
  renewal_details_modal_title: 'Details',
  renewal_modem_deposit: 'Deposit',
  renewal_modem_capacity: 'Capacity',
  renewal_modem_deposit_label: 'Modem deposit',
  renewal_modem_first_time_install: 'First time installation',
  renewals_summary_step_title: 'My selection',
  renewals_summary_step_desc: 'My plan',
  renewals_summary_step_total_cost: 'Total Cost',
  renewals_summary_step_total_cost_subtitle: 'This is the price you will be paying',
  renewals_monthly: '%1$s monthly',
  renewals_summary_step_breakdown: 'Breakdown',
  renewals_summary_step_new_mobile_plan: 'Your new Fix plan',
  renewals_summary_step_breakdown_monthly: 'Monthly',
  renewals_summary_step_discount: 'Discount',
  renewals_summary_step_discount_total_payment: 'Total to pay',
  renewals_summary_step_first_bill: 'First bill',
  renewals_detail_modal_subtitle: 'Why my Next bill is %1$s?',
  renewals_detail_modal_desc: 'Your first bill may be different to the monthly payment because you will be switching plan mid month.',
  renewals_detail_modal_monthly_fee: 'Monthly fee',
  renewals_detail_modal_new_plan_bill: 'New plan bill',
  renewals_detail_modal_total_cost: '%1$s Lekë',
  renewals_detail_modal_total: 'Total',
  renewals_order_completion_error: 'Something went wrong',
  renewals_order_completion_success: 'Order sent',
  renewals_order_completion_success_default_desc: 'The request was sent. Once the appropriate verifications are done the installation team will contact you to proceed. Meanwhile, you can check the status of the request in My Orders.',
  renewals_order_completion_error_default_desc: 'Something went wrong!',
  //ID step
  renewals_id_personal_number_label: 'Personal number',
  renewals_id_nipt_label: 'NIPT',
  renewals_id_nipt_or_personal_label: 'Personal number or NIPT',

  renewals_id_name_label: 'Name',
  renewals_id_surname_label: 'Surname',
  renewals_id_identification_type_label: 'Identification type',
  renewals_id_issuing_country_label: 'Issuing country',
  renewals_id_month_label: 'Month',
  renewals_id_day_label: 'Day',
  renewals_id_year_label: 'Year',
  renewals_expiration_day_label: 'Expiration day',
  renewals_expiration_month_label: 'Expiration month',
  renewals_expiration_year_label: 'Expiration year',
  renewals_id_type: 'ID type',
  renewals_manual_personal_id: 'Personal ID',
  renewals_manual_nipt: 'NIPT',
  renewals_id_wrong_name_format: 'Please write your name correctly.',
  renewals_id_wrong_surname_format: 'Please write your surname correctly.',
  renewals_id_wrong_personal_number_format: 'Please write your personal number correctly. ',
  renewals_id_uploaded_photos: 'Photos uploaded',
  //Purchase coverage
  search_input_label: 'Search address',
  notify_me_title: 'Notify me',
  notify_me_subtitle: 'No Connectity in your area',
  notify_me_desc: 'By are actively listening to you. We are currently working in expanding our coverage everywhere. We will give you a call once we have expanded in your area.',
  notify_me_cancel_button_label: 'Close',

  //camera step
  renewals_camera_front_id: 'Take a picture of the front part of your ID',
  renewals_camera_back_id: 'Take a picture of the back part of your ID',
  renewals_camera_continue: 'Continue',
  renewals_camera_retake_photo: 'Retake photo',
  renewals_camera_selfie: 'Take a photo of your face',
  renewals_camera_permission_denied: 'Permission denied',
  renewals_camera_permission_denied_subtitle: 'You need to give access to camera to take photos. Go to settings to give camera permissions',
  renewals_camera_unavailable: 'Camera unavailable',
  renewals_camera_unavailable_subtitle: 'You cannot use this feature because camera is unavailable in your device',
  renewals_camera_go_to_settings: 'Go to settings',
  renewals_camera_permission_denied_ios_subtitle: 'You need to give access to camera and microphone to take photos. Go to settings to give camera permissions',

  //Summary
  terms_and_conditon_label: "By tapping 'Confirm', you accept our",
  link_terms_and_policy_label: 'terms and conditions',
  order_complete_title: 'Order complete',
  order_complete_description: 'The request was sent. Once the appropriate verifications are done the installation team will contact you to proceed. Meanwhile, you can check the status of the request in My Orders.',
  go_to_dashboard_label: 'Go to dashboard',
  id_verification_title: 'ID Verification',
  id_verification_close_modal: 'Try again',
  id_verification_register_new_id: 'Register with the new ID',
  id_verification_modal_title: 'Something went wrong!',
  id_verification_modal_desc: 'Your ID verification did not match. Could you please make sure the personal number you are giving is correct?',

  renewal_summary_delivery_section_subtitle: 'Delivery address',
  renewals_my_tv: 'My TV',


  renewals_summary_delivery_section_title: 'Delivery',
  renewals_summary_total_cost_error: 'We could not get your total price at the moment. Please try again!',
  renewals_installation_modem_note: 'The two modems we are providing will perform great with our offered speed.',
  renewals_installation_free_modem: 'Free',
  renewals_installation_modem_capacity: 'Up to 8',
  renewals_summary_step_monthly_payment: 'Monthly',
  renewals_view_details: 'More info',
  renewals_terms_title: 'Terms & Conditions',
  renewals_policy_title: 'Return policy',
  renewals_id_card_subtitle: 'Verify your identification',
  purchase_customer_verification_error_title: 'Something went wrong!',
  purchase_customer_verification_error_message: 'Something went wrong in verifying your number',
  renewals_tv_offer_error: "We couldn't load TV offers ate the moment! Please try again",
  renewals_tv_offer_error_retried: "We couldn't load TV offers ate the moment! Please try again or continue without a TV offer",
  renewals_tv_resources_info: '* These devices will be added from your TV offer selection ',
  Month: 'Month',
  Months: 'Months',
  renewals_default_error: 'Something went wrong',
  renewals_no_offers_error: 'Could not load offers at the moment!',

  renewals_summary_step_delivery_at: '%1$s at %1$s',

  //url
  purchase_return_policy_url: 'https://api-web-ci-vfal.vodafone.com/file/ReturnPolicy/ReturnPolicyEN.html',
  renewals_return_policy_url: 'https://api-web-ci-vfal.vodafone.com/file/ReturnPolicy/ReturnPolicyEN.html',
  purchase_terms_url: 'https://api-web-ci-vfal.vodafone.com/file/TermsAndCondFIX/TermsAndCondEN.html',
  renewals_terms_url: 'https://api-web-ci-vfal.vodafone.com/file/TermsAndCondFIX/TermsAndCondEN.html',
  purchase_more_info_url: 'https://api-web-ci-vfal.vodafone.com/file/ShikoDetajetPurchase/ShikoDetajetEN.html',
  renewals_more_info_url: 'https://api-web-ci-vfal.vodafone.com/file/ShikoDetajetRenewal/ShikoDetajetEN.html',

  renewals_procesing: 'Processing',
  go_to_next_step: 'Send me to the next step',
  upload: 'Upload',
  upload_another: 'Upload another image',
  no_preview: 'No image preview'

}
export default en
